<template>
  <el-dialog
    title="查重报告"
    :visible.sync="dcReportVisible"
    width="750px"
    :before-close="handleClose"
  >
    <table width="100%" cellpadding="5" border="0" class="tm_table_form">
      <tbody>
<!--        <tr>-->
<!--          <th width="150px;">文章id:</th>-->
<!--          <td>{{dcReport.paperid}}</td>-->
<!--        </tr>-->
<!--        <tr>-->
<!--          <th width="150px;">复写率:</th>-->
<!--          <td>-->
<!--            {{ dcReport.duplicatepercentage || 0}}%-->
<!--          </td>-->
<!--        </tr>-->
        <tr>
          <th>报告下载地址:</th>
          <td>
            <a id="paperdownurl1" href="javascript:void(0);" @click="to(dcReport.paperdownurl)" >点击下载</a>
          </td>
        </tr>
        <tr>
          <th>论文字数:</th>
          <td>{{dcReport.paperword}}</td>
        </tr>
<!--        <tr>-->
<!--          <th>他引率:</th>-->
<!--          <td>-->
<!--            {{ dcReport.paichupercentage || 0 }}%-->
<!--          </td>-->
<!--        </tr>-->
        <tr>
          <th>报告在线查看地址:</th>
          <td>
            <a id="paperviewurl1" href="javascript:void(0);" @click="to(dcReport.paperviewurl)" >点击去查看</a>
          </td>
        </tr>
        <tr>
          <th>检测状态:</th>
          <td>{{dcReport.filestateid == 2 ? '检测成功' : '检测失败'}}</td>
        </tr>
<!--        <tr>-->
<!--          <th>自写率:</th>-->
<!--          <td>{{dcReport.ownpercentage||0}}%</td>-->
<!--        </tr>-->
        <tr>
          <th>相似率:</th>
          <td>{{dcReport.percentage||0}}%</td>
        </tr>
        <tr>
          <th>报告编号:</th>
          <td>{{dcReport.paperguid}}</td>
        </tr>
<!--        <tr>-->
<!--          <th>引用率:</th>-->
<!--          <td>-->
<!--            {{dcReport.quotepercentage||0}}%-->
<!--          </td>-->
<!--        </tr>-->
<!--        <tr>-->
<!--          <th>自引率:</th>-->
<!--          <td>-->
<!--            {{dcReport.selfyypercentage||0}}%-->
<!--          </td>-->
<!--        </tr>-->
        <tr>
          <th>检测时间:</th>
          <td>{{dcReport.checkdate}}</td>
        </tr>
<!--        <tr>-->
<!--          <th>其他信息:</th>-->
<!--          <td>{{dcReport.papermsg}}</td>-->
<!--        </tr>-->
      </tbody>
    </table>
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" type="primary" @click="dcReportVisible = false"
        >关闭</el-button
      >
    </span>
  </el-dialog>
</template>

<script>
export default {
  data() {
    return {
      dcReportVisible: false,
      dcReport:{}
    };
  },
  methods:{
    open(res){
        this.dcReport=res
      this.dcReportVisible = true;
    },
    handleClose() {
      this.dcReportVisible = false;
      this.dcReport={}
    },
    to(s_file_path){
      let url=decodeURIComponent(s_file_path)
      const a = document.createElement("a");
      a.href = url;
      a.target = "_blank";
      a.download = url;
      a.style.display = "none";
      document.body.append(a);
      a.click();
      document.body.removeChild(a);
    }
  }
};
</script>

<style></style>
